var _defs, _path, _circle, _animateTransform;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinnerShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t.spinner-cls-1 {\r\n\t\t\t\tfill:#fff;\r\n\t\t\t}\r\n\t\t"))), /*#__PURE__*/React.createElement("g", {
    className: "SpinnerLayer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 20,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "spinner-cls-1",
    d: "M22.5,40.925A18.446,18.446,0,0,1,4.075,22.5,18.744,18.744,0,0,1,12.611,6.93,1.474,1.474,0,0,1,14.22,9.4,15.793,15.793,0,0,0,7.025,22.515a15.475,15.475,0,0,0,30.95-.014c0-8.211-5.45-11.773-7.153-13.077A1.536,1.536,0,0,1,30.329,7.4a1.459,1.459,0,0,1,2.027-.493A18.443,18.443,0,0,1,22.5,40.925Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "spinner-cls-1",
    cx: 22.5,
    cy: 6.769,
    r: 2.95
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 22.5 22.5",
    to: "360 22.5 22.5",
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerShape);
export default __webpack_public_path__ + "static/media/SpinnerShape.e5441159d94c08b0533c8d24f435ad0c.svg";
export { ForwardRef as ReactComponent };